import React from "react";
import "./index.css";
import ImgAmigoLeo from "../../assets/images/pngs/logoTelas.png";
import BusinessIcon from "@mui/icons-material/Business";
import CallIcon from "@mui/icons-material/Call";
import {Link} from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";

export default function FooterDeslogado() {
  return (
    <>
      <div className="footerLogado">
        <div className="row p-2">
          <div className="col-md-8 d-flex justify-content-center p-5">
            <div className="d-flex align-items-center flex-column flex-md-row text-sm-center text-md-start">
              <img
                src={ImgAmigoLeo}
                alt="logo amigo leo"
                style={{
                  height: "auto",
                  width: "auto",
                  maxHeight: "80px",
                  maxWidth: "100%",
                }}
               />
              <div className=" ms-3">
                <div>Central de Atendimento Amigo Leo</div>
                <div>Telefone: 0800 591 0127</div>
                <div>(segunda a sexta-feira, das 9h às 18h)</div>
              </div>
            </div>
          </div>
          <div className="col-md-4 d-flex justify-content-center p-5">
            <div className="d-flex align-items-center">
              <div className=" ms-3 d-flex justify-content-end  flex-column">
                <div>Siga nossas redes:</div>
                <div className=" d-flex justify-content-around">
         
                    <FacebookIcon className="pointer" onClick={()=> {window.open("https://www.facebook.com/LeoMadeiras")}} />
                    <InstagramIcon className="pointer" onClick={()=> {window.open("https://www.instagram.com/leomadeiras")}} />
                    <YouTubeIcon className="pointer" onClick={()=> {window.open("https://www.youtube.com/channel/UCcytRsBD6dNhosoX6gpzEmA")}} />
               
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
